import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CatalogNavItem } from '@shared-lib/models/domain-catalog.models';

@Component({
  selector: 'app-catalog-side-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './catalog-side-panel.component.html',
  styleUrl: './catalog-side-panel.component.scss',
})
export class CatalogSidePanelComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() items: CatalogNavItem[] = [];
  @Input() activeId = '';
  /** Unsaved change count per catalog id; drives the per-card pending badge. */
  @Input() pendingCounts: Record<string, number> = {};
  @Input() canAddCatalog = true;
  @Input() hoverSelection = true;
  @Output() select = new EventEmitter<string>();
  @Output() addCatalog = new EventEmitter<void>();
  @Output() remove = new EventEmitter<string>();
}
